module.exports = __webpack_public_path__ + "static/img/icon_user.2b39cf22.svg";